import { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import CompanyClasses from "../../../landing-pages/Company/company.module.css";
import PagedListModel from "../../../models/common/PagedListModel";
import { SortDirection } from "../../../models/enums/SortDirectionEnum";
import relatedShortlistedProfilesService from "../../../services/company/related-shortlisted-profiles-service";
import toasterUtils from "../../../utils/toaster-utils";
import IdNameModel from "../../../models/common/IdNameModel";
import ShortlistedProfilesGridComponent from "./ShortlistedProfilesGridComponent";
import ShortlistedProfilesGridModel from "../../../models/company/relatedAndShortlistedProfiles/response/ShortlistedProfilesGridModel";
import ShortlistedProfilesSearchInputModel from "../../../models/company/relatedAndShortlistedProfiles/request/ShortlistedProfilesSearchInputModel";
import RelatedProfilesRequestModel from "../../../models/company/relatedAndShortlistedProfiles/request/RelatedProfilesRequestModel";
import addProfilesService from "../../../services/company/add-profiles-service";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import modalUtils from "../../../utils/modal-utils";
import RatingDetailsPopUp from "../../candidate/dashboard/RatingDetailsComponent";
import ShortlistedProfileStatusUpdateRequestModel from "../../../models/company/relatedAndShortlistedProfiles/request/ShortlistedProfileStatusUpdateRequestModel";
import { PagingEnum } from "../../../models/enums/IAIEnum";
import masterDataService from "../../../services/master-data-service";
import { FormControl, InputLabel, MenuItem, Select, Button, Autocomplete, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface ShortlistedProfilesProps {
    secondarySkillList: IdNameModel[];
    ratingList: IdNameModel[];
    requirementId: string;
};

const ShortlistedProfilesComponent = (props: ShortlistedProfilesProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [shortlistedProfilesPagedList, setShortlistedProfilesPagedList] = useState<PagedListModel<ShortlistedProfilesGridModel>>();
    const [shortlistedProfilesList, setShortlistedProfilesList] = useState<ShortlistedProfilesGridModel[]>([]);
    const [refreshShortlistedProfiles, setRefreshShortlistedProfiles] = useState<number>(2);
    const [totalRatingSearch, setTotalRatingSearch] = useState<number>(0);
    const [secondarySkillSearch, setSecondarySkillSearch] = useState<number>(0);
    const [candidateNameFilter, setCandidateNameFilter] = useState<string>("");
    const [page, setPage] = useState<number>(PagingEnum.page);
    const [pageSize, setPageSize] = useState<number>(PagingEnum.pageSize);
    const [sortColumn, setSortColumn] = useState<string>("CandidateName");
    const [sortDirection, setSortDirection] = useState<number>(PagingEnum.sortDirection);
    const [pageSizesList, setPageSizesList] = useState<number[]>([]);

    useEffect(() => {
        loadPageSizes();
        getShortlistedProfiles(getSearchFilters(candidateNameFilter, page, pageSize, sortColumn, sortDirection));
    }, []);

    const loadPageSizes = () => {
        masterDataService.loadPageSizesForPaging().then((res) => {
            setPageSizesList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getSearchFilters = (candidateNameFilter: string, page: number, pageSize: number, sortColumn: string, sortDirection: number) => {
        var inputData: ShortlistedProfilesSearchInputModel = {
            requirementId: props.requirementId,
            totalRating: totalRatingSearch === 0 ? null : totalRatingSearch,
            secondarySkillId: secondarySkillSearch === 0 ? null : secondarySkillSearch,
            candidateName: candidateNameFilter,
            page: page,
            pageSize: pageSize,
            sort: sortColumn,
            sortDir: sortDirection
        };
        return inputData;
    };

    const getShortlistedProfiles = (inputData: ShortlistedProfilesSearchInputModel) => {
        setRefreshShortlistedProfiles(2);
        if (loggedInUser?.profileId) {
            modalUtils.showLoader();
            relatedShortlistedProfilesService.getShortlistedProfilesGrid(inputData).then((res) => {
                modalUtils.closeModal();
                setShortlistedProfilesList([]);
                setShortlistedProfilesPagedList(res);
                setShortlistedProfilesList(res.items);
                setRefreshShortlistedProfiles(refreshShortlistedProfiles * 5);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const onStatusUpdateHandler = (objShortlistProfile: ShortlistedProfileStatusUpdateRequestModel) => {
        setRefreshShortlistedProfiles(2);
        modalUtils.showLoader();
        relatedShortlistedProfilesService.updateStatus(objShortlistProfile).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
            getShortlistedProfiles(getSearchFilters(candidateNameFilter, page, pageSize, sortColumn, sortDirection));
        }).catch((error) => {
            setRefreshShortlistedProfiles(refreshShortlistedProfiles * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onRatingDetailsHandler = (objShortlistProfile: RelatedProfilesRequestModel, hasAccess: boolean) => {
        if (hasAccess) {
            modalUtils.showLoader();
            addProfilesService.interviewRatingDetails(objShortlistProfile.interviewId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                const config: GeneralPoupConfig = {
                    title: "Feedback Report",
                    content: (
                        <RatingDetailsPopUp
                            objRatingDetails={res.data}
                        />
                    ),
                    size: ModalSize.XL,
                    className: "model-rating-details-badge"
                };
                modalUtils.showPopup(config);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError("Erorr fetching Schedules");
            });
        } else {
            setRefreshShortlistedProfiles(2);
            modalUtils.showLoader();
            relatedShortlistedProfilesService.saveCandidateAccessToViewProfile(objShortlistProfile).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                getShortlistedProfiles(getSearchFilters(candidateNameFilter, page, pageSize, sortColumn, sortDirection));
            }).catch((error) => {
                setRefreshShortlistedProfiles(refreshShortlistedProfiles * 5);
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const onPageChangeActionHandler = (newPage: number) => {
        setPage(newPage);
        getShortlistedProfiles(getSearchFilters(candidateNameFilter, newPage, pageSize, sortColumn, sortDirection));
    };

    const onPageSizeChangeActionHandler = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(PagingEnum.page);
        getShortlistedProfiles(getSearchFilters(candidateNameFilter, PagingEnum.page, newPageSize, sortColumn, sortDirection));
    };

    const onSortActionHandler = (newSortColumn: string, sortDir: string) => {
        setSortColumn(newSortColumn);
        setSortDirection(sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc);
        getShortlistedProfiles(getSearchFilters(candidateNameFilter, page, pageSize, newSortColumn, sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc));
    };

    const onFilterActionHandler = (filterColumn: string, filterValue: string) => {
        setPage(0);
        setCandidateNameFilter(filterValue);
        getShortlistedProfiles(getSearchFilters(filterValue, 0, pageSize, sortColumn, sortDirection));
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="apply-filter">
                    Filter Candidates <i className="fas fa-filter" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"></i>
                </div>
                <div className="offcanvas offcanvas-end" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasRightLabel">Apply Filter</h5>
                        <a type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></a>
                    </div>
                    <div className="offcanvas-body">
                        <div className="row">
                            <div>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel>Total Rating</InputLabel>
                                    <Select value={totalRatingSearch} onChange={(e) => setTotalRatingSearch(parseInt(e.target.value as string))} label="Total Rating" size="small">
                                        <MenuItem value={0}>All</MenuItem>
                                        {props.ratingList.map((item, index) => (
                                            <MenuItem key={index} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div>
                                <FormControl fullWidth margin="normal">
                                    <Autocomplete options={props.secondarySkillList} value={props.secondarySkillList.find((x) => x.id === secondarySkillSearch) || null}
                                        onChange={(_, newValue) => setSecondarySkillSearch(newValue ? newValue.id : 0)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Secondary Skill" size="small" margin="normal" fullWidth />
                                        )}
                                    />
                                </FormControl>
                            </div>
                            <div className="text-center">
                                <Button variant="contained" color="primary" type="submit"
                                    onClick={() => getShortlistedProfiles(getSearchFilters(candidateNameFilter, page, pageSize, sortColumn, sortDirection))} startIcon={<SearchIcon />}>
                                    Search
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                {refreshShortlistedProfiles > 2 &&
                    <ShortlistedProfilesGridComponent
                        key={refreshShortlistedProfiles}
                        shortlistedProfilesList={shortlistedProfilesList}
                        requirementId={props.requirementId}
                        totalSize={shortlistedProfilesPagedList?.totalCount ? shortlistedProfilesPagedList?.totalCount : shortlistedProfilesList.length}
                        currentPage={page + 1}
                        pagesize={pageSize}
                        sortColumn={sortColumn}
                        sortDirection={sortDirection === SortDirection.Asc ? "asc" : "desc"}
                        pageSizesList={pageSizesList}
                        candidateNameFilterValue={candidateNameFilter}
                        onStatusUpdate={onStatusUpdateHandler}
                        onRatingDetails={onRatingDetailsHandler}
                        onPageChangeAction={onPageChangeActionHandler}
                        onPageSizeChangeAction={onPageSizeChangeActionHandler}
                        onSortAction={onSortActionHandler}
                        onFilterAction={onFilterActionHandler} />
                }
            </div>
        </div>
    );
};
export default ShortlistedProfilesComponent;